class Video {
    constructor(videoWrapper) {
        Object.defineProperty(this, "wrapper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "trigger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "videoWrapper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "videoEmbed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.wrapper = videoWrapper;
        this.trigger = this.wrapper.querySelector('.video-play');
        this.videoWrapper = this.wrapper.querySelector('.video-wrapper');
        this.videoEmbed = this.wrapper.querySelector('iframe');
        this.trigger?.addEventListener('click', this.playVideo.bind(this));
    }
    playVideo() {
        if (this.videoEmbed) {
            const currentSource = this.videoEmbed.getAttribute('src') ?? '';
            const separator = currentSource.includes('?') ? '&' : '?';
            this.videoEmbed.setAttribute('src', `${currentSource}${separator}autoplay=1`);
            this.videoWrapper?.classList.add('played');
        }
    }
}
export default function video() {
    const video = document.querySelectorAll('.block-video');
    for (const element of video) {
        new Video(element);
    }
}
